export const BAUD_RATES = [1200, 2400, 4800, 9600, 19200, 38400, 57600, 115200];
export const DATA_BITS_OPTIONS = [7, 8].map(v => ({ label: String(v), value: v }));
export const STOP_BITS_OPTIONS = [1, 2].map(v => ({ label: String(v), value: v }));
export const SERIAL_PROTOCOL_OPTIONS = [
  { label: 'Modbus RTU', value: 1 },
  { label: 'Modbus ASCII', value: 2 },
];

export const CONNECTION_TYPE_OPTIONS = [
  { label: 'TCP', value: 'tcp' },
  { label: 'Serial COM Port', value: 'serial' },
];

export function buildParityOptions(t: (key: string) => string) {
  return [
    { label: t('commLoops.parityNone'), value: 0 },
    { label: t('commLoops.parityOdd'), value: 1 },
    { label: t('commLoops.parityEven'), value: 2 },
  ];
}

export function buildTcpFields(frogClients: { label: string; value: string }[], t: (key: string) => string) {
  return {
    frog_client_id: {
      type: 'select',
      label: t('commLoops.assignedSupervisorClient'),
      options: frogClients,
      errorText: t('common.required'),
    },
    ip_address: {
      type: 'text',
      label: t('commLoops.ipAddress'),
      errorText: t('common.required'),
    },
    port: {
      type: 'text',
      label: t('commLoops.port'),
      errorText: t('common.required'),
    },
  };
}

export function buildSerialFields(frogClients: { label: string; value: string }[], t: (key: string) => string) {
  return {
    frog_client_id: {
      type: 'select',
      label: t('commLoops.assignedSupervisorClient'),
      options: frogClients,
      errorText: t('common.required'),
    },
    serial_port: {
      type: 'text',
      label: t('commLoops.serialPort'),
      errorText: t('common.required'),
    },
    baud_rate: {
      type: 'select',
      label: t('commLoops.baudRate'),
      options: BAUD_RATES.map(rate => ({ label: String(rate), value: rate })),
      errorText: t('common.required'),
    },
    data_bits: {
      type: 'select',
      label: t('commLoops.dataBits'),
      options: DATA_BITS_OPTIONS,
      errorText: t('common.required'),
    },
    parity: {
      type: 'select',
      label: t('commLoops.parity'),
      options: buildParityOptions(t),
      errorText: t('common.required'),
    },
    stop_bits: {
      type: 'select',
      label: t('commLoops.stopBits'),
      options: STOP_BITS_OPTIONS,
      errorText: t('common.required'),
    },
    protocol: {
      type: 'select',
      label: t('commLoops.protocol'),
      options: SERIAL_PROTOCOL_OPTIONS,
      errorText: t('common.required'),
    },
  };
}
